import _get from "lodash/get";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { StyleSheet } from 'react-native';
import AbstractField from './AbstractField';
const styles = StyleSheet.create({
  padding: {
    paddingLeft: 10
  },
  margin: {
    marginBottom: 10
  }
});

class BooleanField extends AbstractField {
  getDefaultWidget() {
    const {
      widgets
    } = this.props;
    return widgets.HiddenWidget;
  }

  getWidget() {
    const {
      widgets,
      uiSchema
    } = this.props;
    const widgetName = uiSchema['ui:widget'];

    const trueText = _get(uiSchema, ['ui:options', 'trueText'], 'Yes');

    const trueValue = _get(uiSchema, ['ui:options', 'trueValue'], true);

    const falseText = _get(uiSchema, ['ui:options', 'falseText'], 'No');

    const falseValue = _get(uiSchema, ['ui:options', 'falseValue'], false);

    let Widget;

    if (!widgetName || widgetName === 'checkbox') {
      const {
        CheckboxWidget
      } = widgets;

      Widget = ({
        value,
        ...props
      }) =>
      /*#__PURE__*/
      // eslint-disable-line
      React.createElement(CheckboxWidget, _extends({}, props, {
        value: trueValue,
        checked: value === trueValue
      }));
    } else if (widgetName === 'radio' || widgetName === 'radiobox') {
      const {
        RadioWidget
      } = widgets;
      const inlineOptions = uiSchema['ui:options'] && uiSchema['ui:options'].inline;

      Widget = ({
        value,
        style,
        ...props
      }) =>
      /*#__PURE__*/
      // eslint-disable-line
      React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioWidget, _extends({}, props, {
        auto: uiSchema['ui:inline'] || inlineOptions,
        text: trueText,
        checked: value === trueValue,
        style: [uiSchema['ui:inline'] && uiSchema['ui:title'] !== false ? styles.padding : null, !uiSchema['ui:inline'] ? styles.margin : null, style],
        value: trueValue
      })), /*#__PURE__*/React.createElement(RadioWidget, _extends({}, props, {
        auto: uiSchema['ui:inline'] || inlineOptions,
        text: falseText,
        checked: value === falseValue,
        style: [uiSchema['ui:inline'] || inlineOptions ? styles.padding : null, !uiSchema['ui:inline'] ? styles.margin : null, style],
        value: falseValue
      })));
    }

    return Widget;
  }

}

export default BooleanField;